var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 25,
    viewBox: "0 0 179 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.167 0C164.167 1.325 165.48 3.30357 166.809 4.96429C168.519 7.10714 170.561 8.97679 172.903 10.4036C174.659 11.4732 176.787 12.5 178.5 12.5M178.5 12.5C176.787 12.5 174.657 13.5268 172.903 14.5964C170.561 16.025 168.519 17.8946 166.809 20.0339C165.48 21.6964 164.167 23.6786 164.167 25M178.5 12.5H0",
    stroke: "#F0E1CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrower);
export default __webpack_public_path__ + "static/media/arrower.20e245d0cd834a4405f42e9eaf791399.svg";
export { ForwardRef as ReactComponent };